import Button from "components/ui/Button";
import NotFoundImage from "images/404.png";
import { routes } from "pages/routes";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCatalog = () => {
    navigate(routes.libraryRoot.path(), { replace: true });
  };

  const handleDashboard = () => {
    navigate(routes.root.path(), { replace: true });
  };

  return (
    <div className="error-container">
      <div className="error-content-container">
        <div className="error-conatiner-right">
          <span className="error-heading">{t("Errors.headings.oops")}</span>
          <span className="error-title">{t("Errors.notFound.title")} </span>
          <span className="error-description">{t("Errors.notFound.description")}</span>
          <div className="error-button-container">
            <Button onClick={handleCatalog}>{t("Errors.actions.browseCatalog")}</Button>
            <Button variant="secondary" onClick={handleDashboard}>
              {t("Errors.actions.goToDashboard")}
            </Button>
          </div>
        </div>
        <div className="error-conatiner-left">
          <img src={NotFoundImage} alt="" />
        </div>
      </div>
    </div>
  );
};
